import { AxiosError } from "axios";
import { axiosFinancial, createAuthHeaders } from "./financialApi";
import { CommissionFilters, CommissionPaginatedResponse } from "@/models/commission-report.model";

export const getConsigCommissions = async (
  filters: CommissionFilters,
  page: number,
  pageSize: number
): Promise<CommissionPaginatedResponse> => {
  const endpoint = filters.type === "b2b" ? "/api/consignado/b2b-paginated" : "/api/consignado/b2c-paginated";
  const response = await axiosFinancial.get(endpoint, {
    params: { ...filters, page, pageSize },
    headers: createAuthHeaders(),
  });
  return response.data;
};

export const downloadConsigCommissionsB2C = async (
  startDate: Date | string | null,
  endDate: Date | string | null,
  corbanIds: number[]
): Promise<void> => {
  const params: Record<string, any> = {
    startDate,
    endDate,
    corbanIds: corbanIds.join(",")
  };

  try {
    const response = await axiosFinancial.get("/api/consignado/b2c", {
      params,
      responseType: "blob",
      headers: createAuthHeaders(),
    });

    const file = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = "relatorio_propostas_b2c_consignado.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    const decoder = new TextDecoder("utf-8");

    if (error instanceof AxiosError && error.response) {
      const errorResponse = decoder.decode(error.response.data);
      const errorObject = JSON.parse(errorResponse);
      throw new Error(errorObject.error.replace(/^Error:\s/, ""));
    }
    throw new Error(error);
  }
};

export const downloadConsigCommissionsB2B = async (
  startDate: Date | string | null,
  endDate: Date | string | null,
  corbanIds: number[]
): Promise<void> => {
  const params: Record<string, any> = {
    startDate,
    endDate,
    corbanIds: corbanIds.join(",")
  };

  try {
    const response = await axiosFinancial.get("/api/consignado/b2b", {
      params,
      responseType: "blob",
      headers: createAuthHeaders(),
    });

    const file = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = "relatorio_propostas_b2b_consignado.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    const decoder = new TextDecoder("utf-8");

    if (error instanceof AxiosError && error.response) {
      const errorResponse = decoder.decode(error.response.data);
      const errorObject = JSON.parse(errorResponse);
      throw new Error(errorObject.error.replace(/^Error:\s/, ""));
    }
    throw new Error(error);
  }
};